import { resolvers } from './resolvers';
import {
  ApolloClient,
  NormalizedCacheObject,
  InMemoryCache,
} from '@apollo/client';
import typeDefs from './schema';
import { typePolicies } from './typePolicies';

export const client: ApolloClient<NormalizedCacheObject> = new ApolloClient({
  cache: new InMemoryCache({ typePolicies }),
  resolvers,
  typeDefs,
  ...(process.env.NODE_ENV === 'development' && { connectToDevTools: true }),
});
